
const subdomain = `paymentsapi`
export const environments = [
    {
        value: 'staging',
        label: 'STAGING',
        endpoints: {
            auth: `https://${subdomain}-staging.carlile.biz/api/token`,
            api: `https://${subdomain}-staging.carlile.biz`,
        },
    },
    {
        value: 'prod',
        label: 'PRODUCTION',
        endpoints: {
            auth: `https://${subdomain}.carlile.biz/api/token`,
            api: `https://${subdomain}.carlile.biz`,
        },
    },
];